export default __webpack_public_path__ + "static/media/loading.330b7d99.svg";